import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 90.4" {...this.props}><title>segment (large)</title><path d="M3.2 0L0 3.3v11.3l7 6.7 7-6.7V0H3.2zm0 69.1L0 72.4v11.3l7 6.7 7-6.7V69.1H3.2zM6 27.4h2v36H6z" fill="currentColor" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/icons/segment-large.inline.svg